"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Grid_1 = require("@material-ui/core/Grid");
const Hidden_1 = require("@material-ui/core/Hidden");
const Typography_1 = require("@material-ui/core/Typography");
const styles_1 = require("@material-ui/core/styles");
const config_1 = require("@pbl/pbl-react-core/lib/config/config");
const types_1 = require("@pbl/pbl-react-core/lib/models/draws/types");
const DateTimeFormatter_1 = require("@pbl/pbl-react-core/lib/utils/DateTimeFormatter");
const mediaUtil_1 = require("@pbl/pbl-react-core/lib/utils/mediaUtil");
const TimeUtil_1 = require("@pbl/pbl-react-core/lib/utils/TimeUtil");
const _ = require("lodash");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const FeaturedCard_1 = require("../card/FeaturedCard");
const assets_1 = require("../config/assets");
const config_2 = require("../config/config");
const NoResultsFound_1 = require("../no-results/NoResultsFound");
const Pagination_1 = require("../pagination/Pagination");
const stack_1 = require("../stack");
const DrawsScreenStyle_1 = require("./jss/DrawsScreenStyle");
const ProgressiveContent_1 = require("./ProgressiveContent");
class DrawsScreen extends React.Component {
    constructor(props) {
        super(props);
        this.getPagination = (page, classes) => ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12, className: classes.centered }, { children: (0, jsx_runtime_1.jsx)(Pagination_1.default, { first: page.first, last: page.last, activePage: page.number, totalPages: page.totalPages, onSelect: this.props.getNextPage, maxButtons: 4, marginPagesDisplayed: 0, scrollToTopOnChange: false }) })));
        this.getFeatureCard = () => {
            const { featuredPromotion, onCardClicked, t, featuredTitleWrap } = this.props;
            const baseUri = config_2.config.internalConfig.BASE_URL ? config_2.config.internalConfig.BASE_URL : '';
            const image = featuredPromotion.fullImage
                ? (0, mediaUtil_1.createMediaURL)(baseUri, '/media/api/file/', featuredPromotion.fullImage)
                : assets_1.assets.internalAssets.noImage;
            const getStyleType = () => {
                if (featuredPromotion.isEnded()) {
                    return 'GrayedOut';
                }
                if (featuredPromotion.isEndingSoon()) {
                    return 'WhiteHighlight';
                }
                return 'Active';
            };
            return ((0, jsx_runtime_1.jsxs)(FeaturedCard_1.default, Object.assign({ onButtonClick: onCardClicked.bind(this, featuredPromotion), buttonText: t('draws.viewDetails'), image: image, imageTitle: config_2.config.internalConfig.SHOW_IMAGE_PREFIX
                    ? 'Image of draw ' + featuredPromotion.name
                    : featuredPromotion.name, noImageAsset: assets_1.assets.internalAssets.noImage, title: featuredPromotion.name, text: '', textDescription: featuredPromotion.description ? featuredPromotion.description : '', titleWrap: featuredTitleWrap, showBadge: !!featuredPromotion.getPromotionStatus() ||
                    (!!featuredPromotion.progressivePrize && featuredPromotion.isJackpotReached()), badgeText: !!featuredPromotion.getPromotionStatus()
                    ? this.props.t(`draws.drawStatus.${featuredPromotion.getPromotionStatus()}`)
                    : this.props.t('draws.progressive.maxJackPot'), styleType: getStyleType() }, { children: [this.getSecondChancePromotionContent(), this.getProgressivePromotionContent()] })));
        };
        this.getFeaturedPromotion = () => {
            const { featuredPromotion } = this.props;
            return !_.isEmpty(featuredPromotion) ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Hidden_1.default, Object.assign({ xsDown: true }, { children: (0, jsx_runtime_1.jsx)(stack_1.Stack, { children: this.getFeatureCard() }) })), (0, jsx_runtime_1.jsx)(Hidden_1.default, Object.assign({ smUp: true }, { children: (0, jsx_runtime_1.jsx)(Grid_1.default, { children: this.getFeatureCard() }) }))] })) : null;
        };
        this.getProgressivePromotionContent = () => {
            var _a;
            const { featuredPromotion } = this.props;
            if (_.isEmpty(featuredPromotion) ||
                featuredPromotion.promotionType !== types_1.PromotionType.PROGRESSIVE ||
                (featuredPromotion.promotionType === types_1.PromotionType.PROGRESSIVE &&
                    featuredPromotion.progressivePrize &&
                    !featuredPromotion.progressivePrize.multipler &&
                    !((_a = featuredPromotion.progressivePrize) === null || _a === void 0 ? void 0 : _a.constant))) {
                return null;
            }
            return (0, jsx_runtime_1.jsx)(ProgressiveContent_1.default, { promotion: featuredPromotion });
        };
        this.getSecondChancePromotionContent = () => {
            var _a;
            const { featuredPromotion, classes, t, hackShowFeatureSecondChanceContent } = this.props;
            if (_.isEmpty(featuredPromotion) ||
                (featuredPromotion.promotionType === types_1.PromotionType.PROGRESSIVE &&
                    featuredPromotion.progressivePrize &&
                    (featuredPromotion.progressivePrize.multipler ||
                        ((_a = featuredPromotion.progressivePrize) === null || _a === void 0 ? void 0 : _a.constant))) ||
                !hackShowFeatureSecondChanceContent) {
                return null;
            }
            const getFormattedEntryEndDate = () => {
                var _a;
                if (!featuredPromotion.entryEnd) {
                    return 'TBD';
                }
                const entryEndDate = featuredPromotion.entryEnd || '';
                if ((_a = config_1.react_core_config.internalConfig.dateFormatter) === null || _a === void 0 ? void 0 : _a.drawStartEndDateFormat) {
                    return DateTimeFormatter_1.default.getFormattedDateFromDateString('drawStartEndDateFormat', entryEndDate);
                }
                return (0, TimeUtil_1.formatLongMonthDayCommaYear)(entryEndDate);
            };
            return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.progressiveInnerContent }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "overline", color: 'textPrimary', gutterBottom: true }, { children: t('promotion.entryEnds', 'Entry End Date') })), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "body2", color: 'textPrimary' }, { children: !!getFormattedEntryEndDate() }))] })));
        };
        this.renderPromotionsList = () => {
            const { classes, itemsPerPage, disablePagination, onCardClicked, promotions, page, loading, featuredPromotion, t } = this.props;
            if (!loading &&
                _.isEmpty(featuredPromotion) &&
                (_.isEmpty(page) || (page.number === 0 && promotions.length === 0))) {
                return (0, jsx_runtime_1.jsx)(NoResultsFound_1.default, { title: t('draws.noResultsFound') });
            }
            return ((0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, spacing: 4, className: classes.promotionListContainer }, { children: [!disablePagination &&
                        page &&
                        page.totalElements > itemsPerPage &&
                        this.getPagination(page, classes), promotions.map((promotion) => this.props.getCard(promotion, onCardClicked.bind(this, promotion))), !disablePagination &&
                        page &&
                        page.totalElements > itemsPerPage &&
                        this.getPagination(page, classes)] })));
        };
        this.state = {
            activePage: 1,
            itemsPerPage: props.itemsPerPage
        };
    }
    render() {
        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: { display: 'flex', flexDirection: 'column' } }, { children: [this.props.renderTitle(), (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true }, { children: [this.getFeaturedPromotion(), this.renderPromotionsList()] }))] })));
    }
}
exports.default = (0, styles_1.withTheme)((0, styles_1.withStyles)(DrawsScreenStyle_1.default)((0, react_i18next_1.withTranslation)()(DrawsScreen)));
//# sourceMappingURL=draws-screen.js.map